import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import getSectionStyle from '../../../../../../../../styling/getSectionStyle';
import { PrimaryDark } from '../../../../../../../../styling/theme';
import { EditTitle } from './title';

const TitleWrapper = styled.div`
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${PrimaryDark};
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  pointer-events: all;
  cursor: default;
  white-space: nowrap;
  width: 50%;
  ${(props) => {
    const { nodeType } = props;
    return css`
      ${getSectionStyle[nodeType]};
    `;
  }}
`;

export default class EditSectionTitle extends Component {
  constructor(props) {
    super(props);
    const { updateTitle } = this.props;
    this.state = {
      value: updateTitle,
    };
  }

  inputRef = React.createRef();

  componentDidMount = () => {
    this.inputRef.current.focus();
    const { title } = this.props;
    const defaultTitle = title;
    document.addEventListener('mousedown', (e) => {
      this.handleMousedown(e, defaultTitle);
    });
  };

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleMousedown);
  };

  handleMousedown = (e, defaultTitle) => {
    if (this.inputRef.current && !this.inputRef.current.contains(e.target)) {
      const {
        isEditing,
        updateTitle,
        handleUpdateIsEditing,
        handleUpdateTitle,
        prevUpdatedTitle,
        handleUpdateUserPreferences,
        setTitleEditing,
      } = this.props;

      if (isEditing && !e.target.classList.contains('editTitle')) {
        handleUpdateIsEditing(false);
        setTitleEditing(false);
        if (!updateTitle) {
          handleUpdateTitle(prevUpdatedTitle || defaultTitle);
          handleUpdateUserPreferences(prevUpdatedTitle || defaultTitle);
        }
      }
    }
  };

  handleChange = (e) => {
    const { handleChange } = this.props;
    this.setState({ value: e.target.value });
    handleChange(e);
  };

  render() {
    const { sectionKey, handleOnKeyDown } = this.props;
    const { value } = this.state;
    return (
      <TitleWrapper nodeType={sectionKey}>
        <EditTitle
          ref={this.inputRef}
          nodeType={sectionKey}
          value={value}
          onChange={this.handleChange}
          onKeyDown={handleOnKeyDown}
        />
      </TitleWrapper>
    );
  }
}
